import { render, staticRenderFns } from "./valentin.vue?vue&type=template&id=40132765&scoped=true"
var script = {}
import style0 from "./valentin.vue?vue&type=style&index=0&id=40132765&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40132765",
  null
  
)

export default component.exports